import React, { useState, useEffect, useRef, useMemo } from 'react';
import api from './api';
import './Doctors.css';
import "react-data-table-component-extensions/dist/index.css";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { canDo } from '../utils/canDo';
import "react-datepicker/dist/react-datepicker.css";
import CustomDataTable from './CustomDataTable';
import DataTable from 'react-data-table-component';
import { useLocation } from 'react-router-dom';
import BillPrintReport from './BillPrintReport';

const Billing = ({ onPatientCreation }) => {
  const { auth } = useAuth();
  const navigate = useNavigate();


  const [branches, setBranches] = useState([]);
  const [orgs, setBillOrgs] = useState([]);
  const [patients, setPatients] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [billsCount, setBillsCount] = useState(0);
  const [printBill, setPrintBill] = useState(false);
  const [vBill, setViewBill] = useState(false);
  const [showBillComponent, setShowBillComponent] = useState(false);
  const [finalData, setFinalData] = useState({});
  const [searchInput, setSearchInput] = useState('');
const [searchResults, setSearchResults] = useState([]);
const [isSearching, setIsSearching] = useState(false);
const [patientBills, setPatientBills] = useState([]);
const [isOnBlur, setIsOnBlur] = useState(false);
const [pendingReRoot, setPendingReRoot] = useState(0);
const [pendingMyc, setPendingMyc] = useState(0);
const [toast, setToast] = useState(null);
const [patientSessions,   setPatientSessions]   = useState([]);
const [patientBillsFIFO,  setPatientBillsFIFO]  = useState([]);
const [showSessionPanel,  setShowSessionPanel]   = useState(false);
const [sessionSelections, setSessionSelections]  = useState(new Set());
const [showSessionsModal, setShowSessionsModal]  = useState(false);
const [outstandingSelections, setOutstandingSelections] = useState(new Set());
const showToast = (msg, type = 'info') => {
  setToast({ msg, type });
  setTimeout(() => setToast(null), 3500);
};
  const [newPatient, setNewPatient] = useState({
    branch: auth.branch || 'MedicalYogaTherapyCentre',
    name: '',
    age: '',
    gender: 'male',
    address: "",
    number: "",
    patientCard: "",
    registrationDate: new Date(),
    status: "buyer"
  });

  const [newBill, setNewBill] = useState({
    name: '',
    number: '',
    patientCard: "",
    patientBranch: "",
    invoicedate: new Date(),
    invoicenumber: "MYCPB" + new Date().getDate(),
    total: 0,
    totalbeforetax: 0,
    paid: 0,
    txnid: "cash",
    balance: 0,
    status: "unpaid",
    paymentmode: "cash",
    discount: 0,
    comments: "",
    billorg: "goodlife",
    branch: auth.branch || 'MedicalYogaTherapyCentre'
  });
const location = useLocation();
const stateData = location.state && location.state.statedata;

const initialStateData = useRef(null);
const hasInitializedServices = useRef(false);
const originalQtyMap = useRef({}); // tracks prefilled qty per service _id



useEffect(() => {
        console.log(" useEffect ", searchInput, searchInput.length);
  if (searchInput.length < 4 || isOnBlur == true) {
    setSearchResults([]);
    //setIsOnBlur(false);
    return;
  }

  const fetchSearchResults = async () => {
    try {
      setIsSearching(true);
      const response = await api.get(`${process.env.REACT_APP_URL}/patients/profiles/search/${searchInput}`);
      //const response = await api.get(`${process.env.REACT_APP_URL}/patients/profiles`);
      //console.log("PC ==> ", response);
      //await api.get(`${process.env.REACT_APP_URL}/bills/PBG99999`);
        console.log("response == ", response.data);
    
      setSearchResults(response.data || []);
    } catch (error) {
      console.error("Error fetching search results", error);
    } finally {
      setIsSearching(false);
    }
  };

  const delayDebounce = setTimeout(fetchSearchResults, 300); // debounce 300ms
  return () => clearTimeout(delayDebounce);
}, [searchInput]);

useEffect(() => {
   if ( auth && canDo(auth, 'billing.view'))
    {   
      getBranches();
      getPatients();
      getServices();
      getBillOrgs();
    }
  }, []);

useEffect(() => {
  if (stateData) {
    console.log("stateData = ", stateData);
    initialStateData.current = stateData;

    if (stateData.patientCData) {
      setNewPatient(prev => ({
        ...prev,
        ...stateData.patientCData,
      }));
    }

    if (stateData.patientCard) {
      setNewBill(prev => ({
        ...prev,
        patientCard: stateData.patientCard,
        total: 0,
        totalbeforetax: 0,
        balance: 0,
      }));

      getPatientProfile(stateData.patientCard, { skipPatientUpdate: true });
      fetchPatientSessions(stateData.patientCard);
    }
  }
}, [stateData]);

useEffect(() => {
         console.log(" useEffect -- newpatient ", newPatient);
 
  if (!newPatient.branch || newPatient.branch === "selectB") return;

  // ✅ Only auto-generate card if patientCard is empty
  if (newPatient.patientCard?.trim()) return;

  const branch = branches.find(b => b.name.toLowerCase() === newPatient.branch.toLowerCase());
  if (!branch) return;

  const cardId = branch.acr + String(patients.length).padStart(6, "0");
  setBillsCount(patients.length);
  setNewPatient(prev => ({ ...prev, patientCard: cardId }));
}, [newPatient.branch, branches, patients]);

// STEP 1: Update services and selected services
useEffect(() => {
  
  console.log(" useEffect -- incoming ");

  const incoming = initialStateData.current;
  if (hasInitializedServices.current || !incoming?.services || services.length === 0) return;

  // Match incoming PostConsultation services to catalog by name (case-insensitive)
  // Also try matching by _id for precision, and normalize common abbreviations
  const normName = (n) => (n || '').toLowerCase().replace(/\bsr\.?\b/g, 'senior').replace(/\bdr\.?\b/g, 'doctor').trim();

  const matchedCatalogIds = new Set();
  const updatedServices = services.map(service => {
    const svcNorm = normName(service.name);
    const match = incoming.services.find(s => {
      if ((s.qty || 0) <= 0) return false;
      // Try exact _id match first
      if (s._id && service._id && s._id.toString() === service._id.toString()) return true;
      // Then name match with normalization
      return normName(s.name) === svcNorm;
    });
    if (match) {
      matchedCatalogIds.add(service._id);
      return {
        ...service,
        qty: match.qty || 1,
        selected: true
      };
    }
    return service;
  });

  // Services from PostConsultation that didn't match any catalog entry:
  // add them directly so they still appear in the bill with their own amount
  const unmatchedIncoming = incoming.services.filter(s => {
    if ((s.qty || 0) <= 0) return false;
    const sNorm = normName(s.name);
    return !services.some(cat => {
      if (s._id && cat._id && s._id.toString() === cat._id.toString()) return true;
      return normName(cat.name) === sNorm;
    });
  }).map(s => ({
    ...s,
    // Ensure org is present: look up from catalog by name, fallback to first catalog org
    org: s.org || services.find(c => c.org && normName(c.name) === normName(s.name))?.org || services.find(c => c.org)?.org || 'MedicalyogaTherapyCentre',
    _masterQty: s._masterQty || s.qty || 1,
    selected: true,
  }));

  const allServices = [...updatedServices, ...unmatchedIncoming];
  const preselected = allServices.filter(s => s.selected);

  // Store original prefilled qty for highlighting changes
  const qtyMap = {};
  preselected.forEach(s => { qtyMap[s._id] = s.qty || 1; });
  originalQtyMap.current = qtyMap;

  setServices(allServices);
  setSelectedServices(preselected); // ✅ just set — don't call handleServiceChange yet

  hasInitializedServices.current = true;
}, [services]); // re-run when services load so preselection works even if services arrived after stateData

// STEP 2: Recalculate totals whenever selected services change
useEffect(() => {
  if (!selectedServices.length) return;

  console.log("📦 useeffect - selectedServices:", selectedServices);

  let total = 0;
  let totalbeforetax = 0;
  selectedServices.forEach(s => {
    const qty = s.qty || 1;
    console.log("qty =", qty);
    let subtotal = qty * s.amount;

    if (s.sgst && s.cgst && s.sgst > 0  && s.cgst > 0) {
      subtotal += subtotal * (s.sgst + s.cgst) / 100;    
    }
    else if (s.igst) 
    {
        subtotal += subtotal * s.igst / 100;
    }

    if (s.ecess) 
    {
      subtotal += subtotal * s.ecess / 100;
    }
    total += subtotal;
    totalbeforetax += qty * s.amount;
  });

  setNewBill(prev => ({
    ...prev,
    total: total,
    totalbeforetax: totalbeforetax,
    balance: (total - prev.paid - prev.discount)
  }));
}, [selectedServices]);


 const orgList = useMemo(() => {
    const unique = [...new Set(services.map(s => s.org))];
    return unique;
  }, [services]);

  // 🔹 Track which ORGs are selected
  const [selectedOrgs, setSelectedOrgs] = useState([]);//orgList);

  useEffect(() => {
    if (orgList.length > 0) {
      setSelectedOrgs(orgList);
    }
  }, [orgList]);


  // 🔹 Handle checkbox toggle
  const handleOrgToggle = orgName => {
    setSelectedOrgs(prev => {
      if (prev.includes(orgName)) {
        // Uncheck → remove
        return prev.filter(o => o !== orgName);
      } else {
        // Check → add
        return [...prev, orgName];
      }
    });
  };

const toggleSessionGroup = (designation) => {
  setSessionSelections(prev => {
    const next = new Set(prev);
    next.has(designation) ? next.delete(designation) : next.add(designation);
    return next;
  });
};

const payPendingAmount = () => {
  if (!newPatient.patientCard) return showToast('Please select a patient first', 'error');

  // Collect selected outstanding services (pending + refund) from computed list
  const pendingSvcs = servicesByPaymentType
    .filter(s => outstandingSelections.has(s._id) && (s.specialType === 'pending' || s.specialType === 'refund') && (s.amount || 0) > 0)
    .sort((a, b) => a.org === 'ReRoot' ? -1 : b.org === 'ReRoot' ? 1 : 0);

  if (!pendingSvcs.length) return showToast('No outstanding items selected', 'error');

  const selectedBranch = branches.find(b => b.name === newPatient.branch);
  const invNumber = `${selectedBranch?.acr || 'MYC'}${billsCount + 1}`;
  const patientData = { ...newPatient };

  const pBills = pendingSvcs.map((svc, i) => {
    // Refund: negative amount (hospital pays patient); Pending: positive (patient pays hospital)
    const rawAmount = svc.amount || 0;
    const total = svc.specialType === 'refund' ? -rawAmount : rawAmount;
    return {
      orgDetails: orgs.find(o => o.name === svc.org) || { name: svc.org },
      bills: [{ ...svc, qty: 1, amount: total }],
      total,
      totalbeforediscount: total,
      totalbeforetax: total,
      paid: total,
      discount: 0,
      balance: 0,
      paymentmode: newBill.paymentmode || 'Cash',
      txnid: newBill.txnid || '',
      status: 'paid',
      invoicenumber: pendingSvcs.length > 1 ? `${invNumber}-${i + 1}` : invNumber,
      invoicedate: new Date(),
      branch: patientData.branch || auth.branch || 'MedicalYogaTherapyCentre',
      logo: (svc.org || '') + '.jpg',
    };
  });

  const grandTotal = pendingSvcs.reduce((s, svc) => {
    const raw = svc.amount || 0;
    return s + (svc.specialType === 'refund' ? -raw : raw);
  }, 0);
  setFinalData({
    bills: pBills,
    patient: patientData,
    billDetails: {
      ...newBill,
      invoicenumber: invNumber,
      patientCard: patientData.patientCard,
      patientBranch: patientData.branch,
      name: patientData.name,
      number: patientData.number,
      services: pendingSvcs,
      hasSpecial: true,
      total: grandTotal,
      totalbeforetax: grandTotal,
      paid: grandTotal,
      discount: 0,
      balance: 0,
    },
  });
  setShowBillComponent(true);
};

const applySessionAutoFill = () => {
  const toApply = sessionGroups.filter(
    g => sessionSelections.has(g.designation) && g.matchedService
  );
  if (!toApply.length) return;

  // Accumulate counts per service
  const serviceCountMap = {};
  const serviceById = {};
  toApply.forEach(group => {
    const sid = group.matchedService._id.toString();
    serviceCountMap[sid] = (serviceCountMap[sid] || 0) + group.count;
    serviceById[sid] = group.matchedService;
  });

  // Build set of already-selected service ids (user may have edited qty)
  const alreadySelectedIds = new Set(selectedServices.map(s => s._id.toString()));

  // Update the full services list: set qty, use current service rate
  const updatedServices = services.map(svc => {
    const sid = svc._id.toString();
    const autoQty = serviceCountMap[sid];
    if (autoQty) {
      const useQty = alreadySelectedIds.has(sid) ? svc.qty : autoQty;
      return { ...svc, qty: useQty, selected: true };
    }
    return svc;
  });
  setServices(updatedServices);

  // Merge into selectedServices (don't overwrite user-edited qty for existing selections)
  const updatedSelected = [...selectedServices];
  Object.entries(serviceCountMap).forEach(([sid, qty]) => {
    const idx = updatedSelected.findIndex(s => s._id.toString() === sid);
    if (idx >= 0) {
      // Already selected by user — keep their qty
    } else {
      updatedSelected.push({ ...serviceById[sid], qty, selected: true });
      // Track original qty for newly auto-filled services
      originalQtyMap.current[sid] = qty;
    }
  });
  setSelectedServices(updatedSelected);

  // Ensure the org chips for applied services are toggled on
  const appliedOrgs = toApply.map(g => g.matchedService.org).filter(Boolean);
  setSelectedOrgs(prev => [...new Set([...prev, ...appliedOrgs])]);

  // Recalculate bill totals
  let total = 0, totalbeforetax = 0;
  updatedSelected.forEach(s => {
    const qty = s.qty || 1;
    let subtotal = qty * s.amount;
    if (s.sgst > 0 && s.cgst > 0) subtotal += subtotal * (s.sgst + s.cgst) / 100;
    else if (s.igst > 0) subtotal += subtotal * s.igst / 100;
    if (s.ecess > 0) subtotal += subtotal * s.ecess / 100;
    total += subtotal;
    totalbeforetax += qty * s.amount;
  });
  setNewBill(prev => ({ ...prev, total, totalbeforetax, balance: total - prev.paid - prev.discount }));

  setShowSessionPanel(false);
};

const getPatientProfile = (pc, options = {}) => {
  const card = pc || newBill.patientCard;
  console.log("Fetching profile for patientCard: ", card);
  if (!card) return;

  api.get(`${process.env.REACT_APP_URL}/patients/profiles/${card}?t=${Date.now()}`)  // cache buster
    .then(response => {
      if (!response.data) {
        showToast("Patient not found", 'warning');
        return;
      }

      if (options.skipPatientUpdate == false)
      {
        // ✅ Update patient details for the form
        setNewPatient(prev => ({
          ...prev,
          ...response.data
        }));
      }
      // ✅ Optionally update bill details like name and number
      setNewBill(prev => ({
        ...prev,
        name: response.data.name || prev.name,
        number: response.data.number || prev.number
      }));

      getPatientBills("patients");
    })
    .catch(error => console.log('Not found. Please add new Entry!'));
};

const fetchPatientSessions = async (patientCard) => {
  if (!patientCard) return;
  try {
    const [sessRes, billsRes] = await Promise.all([
      api.get(`${process.env.REACT_APP_URL}/appointments/type/Therapy/patient/${patientCard}`),
      api.get(`${process.env.REACT_APP_URL}/bills/${patientCard}`),
    ]);
    setPatientSessions(sessRes.data || []);
    setPatientBillsFIFO(Array.isArray(billsRes.data) ? billsRes.data : []);
  } catch (err) {
    console.error('Session fetch for billing failed:', err);
  }
};

const getpreviousOutstanding = (org, previousbalancedetails) => {
  var dets = previousbalancedetails || [];
  console.log("newPatient = org, dets", org, dets);
  
  for (var i=0; i< dets.length; i++)
  {
    //console.log(" balance dets ", dets[i]["org"]);
    if (dets[i]["org"] == org)
    {
       return Number((Number(dets[i]?.balance || 0)).toFixed(2));
    }
  }
  //console.log("==========");
  return 0;
}

const getAllBillsCount = 
      () => {
          api.get(`${process.env.REACT_APP_URL}/bills/all/count`)
              .then(response => { 
                //console.log("from mongo fetch",response.data);
                setBillsCount(response.data);
              })
              .catch(error =>
                  showToast('Error fetching bills count.', 'error'));
      };

 const getPatientBills = (ur) => {
  if (!stateData || searchResults.length == 0) {
    getAllBillsCount();
    //setBillsCount(0);
    return;
  }
  api.get(`${process.env.REACT_APP_URL}/bills/${ur}`)
  .then(resp => { 
    //console.log("Bills fetched for patient ",resp.data);
    if (resp.data == null)
      {
        showToast("Bills not found", 'warning');
        return;
      }
    setPatientBills(resp.data);
    setBillsCount(patientBills && patientBills.length);

  })
  .catch(error =>
    showToast('Bills not found', 'warning'));
  }
     
  const getPatients = () => {
    api.get(`${process.env.REACT_APP_URL}/patients/profiles`)
      .then(response => setPatients(response.data))
      .catch(err => console.error('Error fetching patients:', err));
  };

  const getBranches = () => {
    api.get(`${process.env.REACT_APP_URL}/branches`)
      .then(response => setBranches(response.data))
      .catch(err => showToast('Error fetching branches', 'error'));
  };

  const getServices = () => {
    api.get(`${process.env.REACT_APP_URL}/services`)
      .then(response => {
        const withQty = response.data.map(s => ({ ...s, _masterQty: s.qty, qty: 1 }));
        setServices(withQty);
        console.log("fetch", withQty);
      })
      .catch(err => showToast('Error fetching services', 'error'));
  };

  const getBillOrgs = () => {
    api.get(`${process.env.REACT_APP_URL}/orgs`)
      .then(response => setBillOrgs(response.data))
      .catch(err => showToast('Error fetching orgs', 'error'));
  };

// Handle selection change for a specific org table
const handleOrgServiceChange = (orgName, selectedRows) => {
  // Skip if still initializing preselections (react-data-table fires onChange on data update)
  if (!hasInitializedServices.current && initialStateData.current?.services?.length > 0) return;

  const selectedIdsForOrg = new Set(selectedRows.map(r => r._id));

  // Build a map of user-edited qty values from current selectedServices
  const prevQtyMap = {};
  selectedServices.forEach(s => { prevQtyMap[s._id] = s.qty; });

  // Keep selections from OTHER orgs unchanged, replace this org's selections
  const otherOrgSelected = selectedServices.filter(s => s.org !== orgName);
  const thisOrgSelected = servicesByPaymentType
    .filter(s => s.org === orgName && selectedIdsForOrg.has(s._id))
    .map(s => ({ ...s, selected: true, qty: prevQtyMap[s._id] ?? (s.qty || 1) }));

  const updatedSelected = [...otherOrgSelected, ...thisOrgSelected];

  // Update main services list
  const updatedServices = services.map(service => ({
    ...service,
    selected: service.org === orgName ? selectedIdsForOrg.has(service._id) : service.selected,
  }));

  setSelectedServices(updatedSelected);
  setServices(updatedServices);

  // Recalculate totals
  let total = 0, totalbeforetax = 0;
  updatedSelected.forEach(s => {
    const qty = s.qty || 1;
    let subtotal = qty * s.amount;
    if (s.sgst && s.cgst && s.sgst > 0 && s.cgst > 0) {
      subtotal += subtotal * (s.sgst + s.cgst) / 100;
    } else if (s.igst) {
      subtotal += subtotal * s.igst / 100;
    }
    if (s.ecess) {
      subtotal += subtotal * s.ecess / 100;
    }
    total += subtotal;
    totalbeforetax += qty * s.amount;
  });

  setNewBill(prev => ({
    ...prev,
    total,
    totalbeforetax,
    balance: (total - prev.paid - prev.discount)
  }));
};

const handleServiceChange = ({ selectedRows }) => {
  if (!hasInitializedServices.current && initialStateData.current?.services?.length > 0) return;

  const selectedIds = new Set(selectedRows.map(r => r._id));

  // Special mode = navigated from ListPatients with pending/refund balance data
  const isSpecialMode = Array.isArray(stateData?.dets) && stateData.dets.length > 0;

  console.log("handleServiceChange", isSpecialMode, servicesByPaymentType);

  // Use correct source based on mode
  const sourceServices = isSpecialMode ? filteredServices : services;

  // Build a map of user-edited qty values from current selectedServices
  const prevQtyMap = {};
  selectedServices.forEach(s => { prevQtyMap[s._id] = s.qty; });

  // Build selected list from correct source — preserve user-edited qty
  const updatedSelected = sourceServices
    .filter(service => selectedIds.has(service._id))
    .map(service => ({
      ...service,
      selected: true,
      qty: prevQtyMap[service._id] ?? (service.qty || 1),
    }));

  // Update main services list (only flag selection, preserve qty)
  const updatedServices = services.map(service => ({
    ...service,
    selected: selectedIds.has(service._id),
  }));

  setSelectedServices(updatedSelected);
  setServices(updatedServices);

  // Recalculate totals
  let total = 0, totalbeforetax = 0;
  updatedSelected.forEach(s => {
    const qty = s.qty || 1;
    let subtotal = qty * s.amount;

    if (s.sgst && s.cgst && s.sgst > 0 && s.cgst > 0) {
      subtotal += subtotal * (s.sgst + s.cgst) / 100;
    } 
    else if (s.igst) {
      subtotal += subtotal * s.igst / 100;
    }

    if (s.ecess) {
      subtotal += subtotal * s.ecess / 100;
    }

    total += subtotal;
    totalbeforetax += qty * s.amount;
  });

  setNewBill(prev => ({
    ...prev,
    total,
    totalbeforetax,
    balance: total - prev.paid - prev.discount,
  }));
};

const setTextValue = (value, id, key) => {
  const rawValue = value; // keep string for input
  const parsed = value === "" ? "" : parseInt(value, 10);

  console.log("setTextValue", services);
  const updated = services.map(service => {
    if (service._id === id) {
      return {
        ...service,
        [key]: parsed
      };
    }
    return service;
  });

  setServices(updated);

  // Update selectedServices too
  const updatedSelected = selectedServices.map(s => {
    if (s._id === id) {
      return {
        ...s,
        [key]: parsed
      };
    }
    return s;
  });

  setSelectedServices(updatedSelected);

  // Recalculate totals ONLY IF value is a valid number
  if (!isNaN(parsed)) {
    let total = 0;
    let totalbeforetax = 0;
    updatedSelected.forEach(s => {
      const qty = s.qty || 1;
      let subtotal = qty * s.amount;

      console.log("subtotal = ", subtotal, s);
      console.log("taxes = ", s.cgst, s.sgst, s.igst, s.ecess);
    
    if (s.sgst && s.cgst && s.sgst > 0  && s.cgst > 0) {
      subtotal += subtotal * (s.sgst + s.cgst) / 100;
      console.log("subtotal with sgst = ", s.sgst ,subtotal * s.sgst / 100 , subtotal);      
    }
    else if (s.igst) 
    {
      console.log("ifgst ?", s.igst);
        subtotal += subtotal * s.igst / 100;
    }

    if (s.ecess) 
    {
      console.log("ecess ?", s.ecess);
      subtotal += subtotal * s.ecess / 100;
    }
    total += subtotal;
    totalbeforetax += qty * s.amount;
    });

    setNewBill(prev => ({
      ...prev,
      total: total,
      totalbeforetax: totalbeforetax,
      balance: (total - prev.paid - prev.discount)
    }));
  }
};

  const checkFormValidity = () => {

    if (!newPatient.name || /^[A-Z]{2,4}0{5,6}$/.test(newPatient.patientCard)) {
      showToast("Please select a patient from the search box.", 'error');
      return false;
    }

    if (selectedServices.length === 0) {
      showToast("Please select at least one service.", 'error');
      return false;
    }

    var hasError = selectedServices.some(s => {      
      const n = s.name.toLowerCase();
      return (s.org === 'ReRoot' && ((n.indexOf('refund') ==-1) && (n.indexOf("pending") == -1)) && (
        s.qtyInStock === undefined || s.qty > s.qtyInStock ) );
    });

    if (hasError) {
      showToast("Insufficient stock qty for one or more selected services.", 'error');
      return false;
    }

    const isPending = s => s.name.toLowerCase().includes("pending");
    const isRefund = s => s.name.toLowerCase().includes("refund");

    // Count each type
    const pendingCount = selectedServices.filter(isPending).length;
    const refundCount  = selectedServices.filter(isRefund).length;
    const total = selectedServices.length;

    // If all are pending → OK
    // If all are refund → OK
    // If all are normal → OK
    // Anything else → ERROR
    hasError = !(
      (pendingCount === total) ||
      (refundCount === total) ||
      (pendingCount === 0 && refundCount === 0)  // all normal
    );

    if (hasError) {
      showToast("Pending Payment or Refund cannot be combined with other services.", 'error');
      return false;
    }

    return true;
  }

  const handleUpdateBill = async (e) => {
    if (e)
      e.preventDefault();
    if (!checkFormValidity()) return;    
    console.log("handleUpdateBill");
    const selectedBranch = branches.find(b => b.name === newPatient.branch);
    const invNumber = `${selectedBranch?.acr || 'MYC'}${billsCount + 1}`;

    const patientData = {
      ...newPatient,
      patientCard: newPatient.patientCard || `${selectedBranch?.acr}${String(patients.length).padStart(6, "0")}`
    };

    var hasSpecial = selectedServices.some(s => {
      const n = s.name.toLowerCase();
      return (n.indexOf('refund') !=-1) || (n.indexOf("pending") != -1);
    });


    const billData = {
      ...newBill,
      invoicenumber: invNumber,
      patientCard: patientData.patientCard,
      patientBranch: patientData.branch,
      name: patientData.name,
      number: patientData.number,
      services: selectedServices,
      hasSpecial: hasSpecial,
    };

    // Build pBills from unique orgs present in selectedServices.
    // ReRoot is always first so its outstanding is cleared before other orgs.
    // Defensive: if any service lacks org, assign default org from catalog or fallback
    const defaultOrg = orgs?.[0]?.name || 'MedicalyogaTherapyCentre';
    selectedServices.forEach(s => {
      if (!s.org) {
        // Try to find matching catalog service for org
        const catMatch = services.find(c => c.org && (c._id?.toString() === s._id?.toString() || (c.name || '').toLowerCase() === (s.name || '').toLowerCase()));
        s.org = catMatch?.org || defaultOrg;
      }
    });
    const uniqueOrgNames = [...new Set(selectedServices.map(s => s.org).filter(Boolean))]
      .sort((a, b) => a === 'ReRoot' ? -1 : b === 'ReRoot' ? 1 : 0);
    console.log("generateBill: selectedServices=", selectedServices.length, "orgs=", uniqueOrgNames, "services=", selectedServices.map(s => ({ name: s.name, org: s.org, qty: s.qty, amount: s.amount })));

    let remainingPaid     = newBill.paid     || 0;
    let remainingDiscount = newBill.discount || 0;

    const pBills = [];
    uniqueOrgNames.forEach((orgName, index) => {
      const matchedServices = selectedServices.filter(s => s.org === orgName);
      if (!matchedServices.length) return;

      // Look up full org details; fall back to a minimal object if orgs haven't loaded yet
      const org = orgs.find(o => o.name === orgName) || { name: orgName };

      let total = 0;
      let totalbeforetax = 0;
      matchedServices.forEach(s => {
        const qty = s.qty || 1;
        let subtotal = qty * s.amount;

        if (s.sgst && s.cgst && s.sgst > 0 && s.cgst > 0) {
          subtotal += subtotal * (s.sgst + s.cgst) / 100;
        } else if (s.igst) {
          subtotal += subtotal * s.igst / 100;
        }
        if (s.ecess) {
          subtotal += subtotal * s.ecess / 100;
        }

        total += subtotal;
        totalbeforetax += qty * s.amount;
      });

      // Distribute discount then payment to this org (ReRoot first due to sort above)
      const orgDiscount    = Math.min(remainingDiscount, total);
      const effectiveTotal = total - orgDiscount;
      const orgPaid        = Math.min(remainingPaid, effectiveTotal);
      remainingDiscount   -= orgDiscount;
      remainingPaid       -= orgPaid;

      pBills.push({
        orgDetails: org,
        bills: matchedServices,
        total: total,
        totalbeforediscount: total,
        totalbeforetax: totalbeforetax,
        paid: orgPaid,
        discount: orgDiscount,
        balance: effectiveTotal - orgPaid,
        paymentmode: billData.paymentmode,
        txnid: billData.txnid,
        status: effectiveTotal - orgPaid > 0 ? "pending" : "paid",
        invoicenumber: uniqueOrgNames.length > 1 ? `${invNumber}-${index + 1}` : invNumber,
        invoicedate: new Date(),
        branch: patientData.branch || auth.branch || 'MedicalYogaTherapyCentre',
        logo: orgName + ".jpg"
      });
    });

       
    const finalData1 = {
      bills: pBills,
      patient: patientData,
      billDetails: billData
    };
    
    setFinalData(finalData1);
    console.log("finalData = ", finalData1);
    if (onPatientCreation) onPatientCreation(finalData1);
    setShowBillComponent(true);
  };

  const serviceColumns = [
  /*  {
      name: "Name",
      selector: row => row?.name,
      sortable: true
    },*/
    {
      name: "Service",
      selector: row => row && row.name,

      sortable: true
    },
    {
      name: "Amount",
      selector: row => row?.amount,
      sortable: true,
      width: "100px"
    },
    {
      name: "Qty",
      selector: row => row?.qty,
      width: "70px",
      cell: (row) => {
        const isPkg = /package/i.test(row.name || '') && Number(row._masterQty || 0) > 1;
        if (isPkg) {
          return <span style={{ fontWeight: 600, fontSize: 13 }}>{row.qty || 1} pkg</span>;
        }
        const isSelected = selectedServices.some(s => s._id === row._id);
        const origQty = originalQtyMap.current[row._id];
        const currentQty = row.qty === "" ? "" : row.qty || 1;
        const isChanged = origQty !== undefined && currentQty !== "" && Number(currentQty) !== origQty;

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <input
                type="number"
                value={currentQty}
                onChange={e => setTextValue(e.target.value, row._id, "qty")}
                min="1"
                required={isSelected}
                style={isChanged ? { border: '2px solid #f59e0b', background: '#fffbeb', borderRadius: 4, width: 40 } : { width: 40 }}
              />
              {isChanged && <span style={{ fontSize: 10, color: '#b45309', fontWeight: 600 }}>was {origQty}</span>}
            </div>
          )}
    },
    {
      name: "In Stock",
      selector: row => row?.qtyInStock || 0,
      sortable: true,
      width: "20px"
    },
  ];

  const serviceTableData = {
    columns: serviceColumns,
    data: services
  };

function handleSearchSelect(inputValue) {
  console.log("handleSearchSelect -- ", inputValue, searchResults)
  
  if (!inputValue || inputValue.length < 4) return;

  const selected = searchResults.find(
    p =>
      `${p.name} (${p.patientCard}) - ${p.number}`.toLowerCase() ===
      inputValue.toLowerCase()
  );
  console.log("handleSearchSelect -- ", selected, newBill);

  if (!selected) return;
console.log("handleSearchSelect -- ", selected, newBill);
  if (newBill.patientCard === selected.patientCard) return;
console.log("handleSearchSelect -- ", selected, inputValue);
  if (selected && inputValue.length > 10) {
    // Reset session panel state for the new patient
    setPatientSessions([]);
    setPatientBillsFIFO([]);
    setShowSessionPanel(false);
    setSessionSelections(new Set());

    var pendingReRoot = Number(getpreviousOutstanding("ReRoot", selected.previousbalancedetails)) || 0;
    setPendingReRoot(pendingReRoot);

    console.log("ReRoot pending val", pendingReRoot);
    // Pending against
    var pendingMyc = Number(getpreviousOutstanding("MedicalyogaTherapyCentre", selected.previousbalancedetails)) || 0;
    setPendingMyc(pendingMyc);
    
    console.log("MYC pending val", pendingMyc);

    setNewPatient(prev => ({ ...prev, ...selected }));

    setNewBill(prev => ({
      ...prev,
      patientCard: selected.patientCard,
      name: selected.name,
      number: selected.number,
      branch: selected.branch
    }));

    getPatientBills("patients");
    fetchPatientSessions(selected.patientCard);

    setSearchInput('');
    setSearchResults([]);
     // 3️⃣ Optionally transform services with previous outstanding balances
    const updatedServices = services.map(service => {
      var outstanding = pendingMyc;
      
      if (service.org == "ReRoot")
        outstanding = pendingReRoot;

        //const outstanding = getpreviousOutstanding(service.org);

        // Determine if this service is special based on both name AND actual outstanding
        const isPendingService = /pending/i.test(service.name) && outstanding > 0;
        const isRefundService = /refund/i.test(service.name) && outstanding < 0;

        if (isPendingService) {
          console.log("isPending", outstanding);
          return {
            ...service,
            amount: outstanding, // positive amount to collect
            specialType: "pending",
          };
        }

        if (isRefundService) {
          console.log("isRefund", outstanding);
          return {
            ...service,
            amount: -outstanding, // positive number, but treated as refund
            specialType: "refund",
          };
        }
      
      console.log("normal");
      // Normal service: leave as is
      return {
        ...service,
        specialType: null,
      };
    });

    setServices(updatedServices);
  }
}

/*
const servicesByPaymentTypeOld = useMemo(() => {
  //if (!stateData?.dets || stateData.dets.length === 0) return services;
  console.log("servicesByPaymentType ", stateData);
   // Caller B: No stateData → fallback mode
  if (!stateData?.dets || stateData.dets.length === 0) {
    return services.map(service => {
      const outstanding = getpreviousOutstanding(service.org);

      const isPending = /pending/i.test(service.name);
      const isRefund = /refund/i.test(service.name);

      if (!isPending && !isRefund) {
        return service; // normal service
      }
      console.log("outstanding = ", outstanding);

      return {
        ...service,
        amount: Math.abs(outstanding),
        specialType: outstanding > 0 ? "pending" : "refund",
      };
    });
  }
  console.log("stateData = filter and map ");
  return services
    .filter(service =>
      stateData.dets.some(det =>
        service.name.toLowerCase().indexOf(det?.filter?.toLowerCase()) != -1 &&
        service.org === det.org
      )
    )    
    .map(service => {
      const match = stateData.dets.find(det =>
        service.name.toLowerCase().indexOf(det?.filter?.toLowerCase()) != -1 &&
        service.org === det.org
      );
      return {
        ...service,
        amount: ((match.balance < 0) ? (-1* match.balance) : match.balance)
      };
    });
}, [services, stateData]);
*/


// Sync pendingReRoot / pendingMyc state whenever stateData changes (side-effects belong here, not in useMemo)
useEffect(() => {
  if (!stateData?.dets) return;
  const rr = Number(getpreviousOutstanding("ReRoot", stateData.dets)) || 0;
  const myc = Number(getpreviousOutstanding("MedicalyogaTherapyCentre", stateData.dets)) || 0;
  setPendingReRoot(rr);
  setPendingMyc(myc);
}, [stateData]);

const servicesByPaymentType = useMemo(() => {
  console.log("servicesByPaymentType ", stateData, services);
  if (!Array.isArray(services) || services.length === 0) return [];

  console.log("servicesByPaymentType ", stateData);

  var pendingMyc = 0;
  var pendingReRoot = 0;
  if (stateData?.dets) {
    pendingReRoot = Number(getpreviousOutstanding("ReRoot", stateData?.dets)) || 0;
    pendingMyc = Number(getpreviousOutstanding("MedicalyogaTherapyCentre", stateData?.dets)) || 0;
  }
  // 🔹 No stateData → derive from outstanding
  if (!Array.isArray(stateData?.dets) || stateData.dets.length === 0) {
    // calculate pending
    
    return services.map(service => {
      var outstanding = pendingMyc;
      
      if (service.org == "ReRoot")
        outstanding = pendingReRoot;
      
      const isPendingName = /pending/i.test(service.name);
      const isRefundName  = /refund/i.test(service.name);
      console.log("isPending isRefund", isPendingName, isRefundName,pendingMyc, pendingReRoot );
      // ⛔ not special if no outstanding
      if ((!isPendingName && !isRefundName) || (outstanding == 0)) {
        console.log("not special ");
        return { ...service, specialType: null };
      }
      
      console.log("special service ", outstanding);

      return {
        ...service,
        amount: Math.abs(outstanding),
        specialType: outstanding > 0 ? "pending" : "refund",
      };
    });
  }

console.log("servicesByPaymentType filter and map");
  // 🔹 stateData mode — return ALL services, mark matching ones with specialType
  return services.map(service => {
    const match = stateData.dets.find(det =>
      service.org === det.org &&
      service.name.toLowerCase().includes(det?.filter?.toLowerCase())
    );

    if (match) {
      const balance = Number(match.balance) || 0;
      return {
        ...service,
        amount: Math.abs(balance),
        specialType: balance > 0 ? "pending" : balance < 0 ? "refund" : null,
      };
    }
    return { ...service, specialType: null };
  });
}, [services, stateData]);

// 2️⃣ Filter the result by orgs
const filteredServices = useMemo(() => {
  if (selectedOrgs.length === 0) return [];
  return servicesByPaymentType.filter(s => selectedOrgs.includes(s.org));
}, [servicesByPaymentType, selectedOrgs]);

// 2.5️⃣ Outstanding items (pending + refund) for checkbox panel
const outstandingItems = useMemo(() => {
  return servicesByPaymentType.filter(s => s.specialType === 'pending' || s.specialType === 'refund');
}, [servicesByPaymentType]);

// 3️⃣ Session-based billing: FIFO allocation identical to PatientDashboard
const sessionGroups = useMemo(() => {
  if (!patientSessions.length || !services.length) return [];

  // Sort all completed sessions oldest-first (same as PatientDashboard FIFO)
  const allCompleted = patientSessions
    .filter(s => s.status === 'Completed' && (s.visitCharges || 0) > 0)
    .slice()
    .sort((a, b) => new Date(a.date || a.start) - new Date(b.date || b.start));

  // Total amount received across all bills
  const totalPaid = patientBillsFIFO.reduce((acc, b) => acc + (b.paid || 0), 0);

  // Allocate payments oldest-first; track partial credit on first unpaid session
  let remaining = totalPaid;
  const paidSet = new Set();
  let firstUnpaidId = null;
  let partialCreditOnFirst = 0;
  allCompleted.forEach(s => {
    const cost = s.visitCharges || 0;
    if (remaining >= cost) {
      paidSet.add(s._id);
    } else if (firstUnpaidId === null) {
      firstUnpaidId = s._id;
      partialCreditOnFirst = Math.max(0, remaining); // how much of this session was already covered
    }
    remaining -= cost;
  });

  const unbilled = allCompleted.filter(s => !paidSet.has(s._id));
  if (!unbilled.length) return [];

  // Fallback service matching by fee proximity
  const fallbackCandidates = [
    /session\s+with\s+doctor/i,
    /session\s+with\s+senior\s+therapist/i,
    /session\s+with\s+therapist/i,
  ].map(pat => services.find(s => pat.test(s.name))).filter(Boolean);

  const knownGrouped = {};
  const fallbackGrouped = {};

  unbilled.forEach(sess => {
    const des = (sess.leadTherapistDesignation || '').trim();
    if (des) {
      if (!knownGrouped[des]) knownGrouped[des] = [];
      knownGrouped[des].push(sess);
    } else if (fallbackCandidates.length) {
      const closest = fallbackCandidates.reduce((best, svc) =>
        Math.abs((svc.amount || 0) - (sess.visitCharges || 0)) <
        Math.abs((best.amount || 0) - (sess.visitCharges || 0)) ? svc : best
      );
      const key = closest._id.toString();
      if (!fallbackGrouped[key]) fallbackGrouped[key] = { service: closest, sessions: [] };
      fallbackGrouped[key].sessions.push(sess);
    }
  });

  // Normalize designation abbreviations for matching
  const normalizeDesignation = (des) => {
    return des
      .replace(/\bsr\b/i, 'senior')
      .replace(/\bjr\b/i, 'junior')
      .replace(/\bdr\b/i, 'doctor')
      .replace(/\bphysio\b/i, 'physiotherapist');
  };

  const knownEntries = Object.entries(knownGrouped).map(([designation, sessList]) => {
    const rawFee = sessList.reduce((s, a) => s + (a.visitCharges || 0), 0);
    // Subtract any partial credit already applied to the first unpaid session in this group
    const credit = sessList.some(s => s._id === firstUnpaidId) ? partialCreditOnFirst : 0;
    const totalFee = rawFee - credit;
    const normDes = normalizeDesignation(designation);
    // Try regex match with normalized designation: "Session with [designation]"
    let matchedService = services.find(s => {
      const normName = normalizeDesignation(s.name || '');
      return new RegExp(`session\\s+with\\s+${normDes.replace(/\s+/g, '\\s+')}`, 'i').test(normName);
    }) || null;
    // Fallback: match by closest fee among session-type services
    if (!matchedService) {
      const avgFeePerSession = rawFee / sessList.length;
      const sessionServices = services.filter(s => /session/i.test(s.name));
      if (sessionServices.length) {
        matchedService = sessionServices.reduce((best, svc) =>
          Math.abs((svc.amount || 0) - avgFeePerSession) < Math.abs((best.amount || 0) - avgFeePerSession) ? svc : best
        );
      }
    }
    return { designation, sessions: sessList, count: sessList.length, totalFee, avgFee: rawFee / sessList.length, matchedService, isFallback: !matchedService };
  });

  const fallbackEntries = Object.values(fallbackGrouped).map(({ service, sessions: sessList }) => {
    const rawFee = sessList.reduce((s, a) => s + (a.visitCharges || 0), 0);
    const credit = sessList.some(s => s._id === firstUnpaidId) ? partialCreditOnFirst : 0;
    const totalFee = rawFee - credit;
    return { designation: `__fb__${service._id}`, sessions: sessList, count: sessList.length, totalFee, avgFee: rawFee / sessList.length, matchedService: service, isFallback: true };
  });

  return [...knownEntries, ...fallbackEntries];
}, [patientSessions, services, patientBillsFIFO]);

// Auto-show panel when session groups are ready
useEffect(() => {
  if (sessionGroups.length > 0) {
    setSessionSelections(new Set(
      sessionGroups.filter(g => g.matchedService).map(g => g.designation)
    ));
    setShowSessionPanel(true);
  }
}, [sessionGroups.length]); // eslint-disable-line react-hooks/exhaustive-deps

// Auto-select all outstanding items when they appear
useEffect(() => {
  if (outstandingItems.length > 0) {
    setOutstandingSelections(new Set(outstandingItems.map(s => s._id)));
  }
}, [outstandingItems.length]); // eslint-disable-line react-hooks/exhaustive-deps


  // Org accent colors (Zomato-style category chips)
  const ORG_COLORS = {
    MedicalyogaTherapyCentre: { bg: '#eef2ff', border: '#818cf8', text: '#4338ca', dot: '#6366f1' },
    ReRoot:                   { bg: '#fdf4ff', border: '#d8b4fe', text: '#7e22ce', dot: '#a855f7' },
    GoodLifeAcademy:          { bg: '#f0fdf4', border: '#86efac', text: '#15803d', dot: '#22c55e' },
    MedicalyogaAssociation:   { bg: '#fff7ed', border: '#fdba74', text: '#c2410c', dot: '#f97316' },
  };
  const getOrgColor = name => ORG_COLORS[name] || { bg: '#f8fafc', border: '#e2e8f0', text: '#475569', dot: '#94a3b8' };

  const patientInitials = (name = '') =>
    name.trim().split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?';

  return (
    <div className="patient-main">

      {/* ── Patient search ── */}
      {!stateData && (
        <div className="search-section">
          <label>Search Patient (Name / Card / Number ):</label>
          <input
            type="text"
            value={searchInput}
            onChange={e => setSearchInput(e.target.value)}
            onInput={e => handleSearchSelect(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') handleSearchSelect(searchInput); }}
            list="patient-options"
            placeholder="Enter at least 4 characters"
          />
          <datalist id="patient-options">
            {searchResults.map((patient, idx) => (
              <option key={idx} value={`${patient.name} (${patient.patientCard}) - ${patient.number}`} />
            ))}
          </datalist>
          {isSearching && <p>Searching...</p>}
        </div>
      )}

      {/* ── Back buttons ── */}
      {stateData && !showBillComponent && !stateData?.dets && (
        <div style={{ marginBottom: '1rem' }}>
          <button
            className="btn btn-secondary"
            onClick={() => navigate('/ListPatients', { state: { data: { fromTab: 'Billing', toTab: 'PostConsultation', pc: stateData.patientCard } } })}
          >
            ← Back to Post Consultation
          </button>
        </div>
      )}
      {stateData && !showBillComponent && stateData?.dets && (
        <div style={{ marginBottom: '1rem' }}>
          <button
            className="btn btn-secondary"
            onClick={() => navigate('/ListPatients')}
          >
            ← Back to All Saadhaks
          </button>
        </div>
      )}

      {!showBillComponent && (
        <div className="form-sections">
          <div style={{ position: 'relative', textAlign: 'center', marginBottom: 6, minHeight: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {!stateData && (
              <button
                type="button"
                title="Clear and start a new bill"
                onClick={() => navigate(0)}
                style={{
                  position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: '1.5px solid #c7d2fe', borderRadius: 8,
                  color: '#6366f1', fontWeight: 700, fontSize: 13,
                  padding: '4px 10px', cursor: 'pointer',
                }}
              >
                ✕ New Bill
              </button>
            )}
            <h4 style={{ margin: 0 }}>Bill Details</h4>
          </div>
          <form onSubmit={handleUpdateBill}>

            {/* ── Patient info banner — compact single row ── */}
            {newPatient.name ? (
              <div style={{
                display: 'flex', alignItems: 'center', gap: 12,
                background: 'linear-gradient(90deg,#eef2ff 0%,#f8fafc 100%)',
                border: '1.5px solid #c7d2fe', borderRadius: 12,
                padding: '10px 16px', marginBottom: 14,
              }}>
                <div style={{
                  width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                  background: 'linear-gradient(135deg,#6366f1,#8b5cf6)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontWeight: 800, fontSize: 14,
                }}>
                  {patientInitials(newPatient.name)}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 15, color: '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {newPatient.name}
                  </div>
                  <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                    <span style={{ background: '#e0e7ff', color: '#4338ca', borderRadius: 4, padding: '1px 6px', fontWeight: 600, marginRight: 8 }}>
                      {newPatient.patientCard}
                    </span>
                    {newPatient.number && <span>📞 {newPatient.number}</span>}
                  </div>
                </div>
                {outstandingItems.length > 0 && (
                  <span style={{ fontSize: 11, color: '#d97706', fontWeight: 600 }}>
                    {outstandingItems.filter(s => s.specialType === 'pending').length > 0 && `Pending ₹${outstandingItems.filter(s => s.specialType === 'pending').reduce((a, s) => a + (s.amount || 0), 0).toLocaleString()}`}
                    {outstandingItems.some(s => s.specialType === 'pending') && outstandingItems.some(s => s.specialType === 'refund') && ' · '}
                    {outstandingItems.filter(s => s.specialType === 'refund').length > 0 && <span style={{ color: '#16a34a' }}>Refund ₹{outstandingItems.filter(s => s.specialType === 'refund').reduce((a, s) => a + (s.amount || 0), 0).toLocaleString()}</span>}
                  </span>
                )}
              </div>
            ) : (
              <div style={{
                display: 'flex', alignItems: 'center', gap: 10,
                background: '#f8fafc', border: '1.5px dashed #cbd5e1',
                borderRadius: 12, padding: '12px 16px', marginBottom: 14,
                color: '#94a3b8', fontSize: 13,
              }}>
                <span style={{ fontSize: 20 }}>👤</span>
                Search for a patient above to auto-fill details
              </div>
            )}

            {/* ── Outstanding Balance Panel (Pending + Refund) ── */}
            {outstandingItems.length > 0 && (() => {
              const toggleOutstanding = (id) => {
                setOutstandingSelections(prev => {
                  const next = new Set(prev);
                  next.has(id) ? next.delete(id) : next.add(id);
                  return next;
                });
              };
              const selectedTotal = outstandingItems
                .filter(s => outstandingSelections.has(s._id))
                .reduce((sum, s) => sum + (s.specialType === 'refund' ? -(s.amount || 0) : (s.amount || 0)), 0);
              return (
                <div style={{ background: '#fef9ee', border: '1.5px solid #fbbf24', borderRadius: 12, padding: '12px 16px', marginBottom: 14 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 15 }}>💰</span>
                    <strong style={{ fontSize: 13, color: '#92400e' }}>Outstanding Balance</strong>
                    <span style={{ marginLeft: 'auto', fontSize: 12, color: '#78350f', fontWeight: 600 }}>
                      Net: ₹{Math.abs(selectedTotal).toLocaleString()} {selectedTotal > 0 ? '(Patient owes)' : selectedTotal < 0 ? '(Refund due)' : ''}
                    </span>
                  </div>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: '#fef3c7' }}>
                        <th style={{ padding: '5px 8px', textAlign: 'left', fontWeight: 700, fontSize: 11, color: '#78350f', borderBottom: '1px solid #fcd34d' }}>✓</th>
                        <th style={{ padding: '5px 8px', textAlign: 'left', fontWeight: 700, fontSize: 11, color: '#78350f', borderBottom: '1px solid #fcd34d' }}>Org</th>
                        <th style={{ padding: '5px 8px', textAlign: 'left', fontWeight: 700, fontSize: 11, color: '#78350f', borderBottom: '1px solid #fcd34d' }}>Type</th>
                        <th style={{ padding: '5px 8px', textAlign: 'right', fontWeight: 700, fontSize: 11, color: '#78350f', borderBottom: '1px solid #fcd34d' }}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {outstandingItems.map((item, i) => (
                        <tr key={item._id} style={{ background: i % 2 === 0 ? '#fff' : '#fffde7' }}>
                          <td style={{ padding: '5px 8px', borderBottom: '1px solid #fef3c7' }}>
                            <input type="checkbox" checked={outstandingSelections.has(item._id)}
                              onChange={() => toggleOutstanding(item._id)} />
                          </td>
                          <td style={{ padding: '5px 8px', borderBottom: '1px solid #fef3c7', fontWeight: 600 }}>{item.org}</td>
                          <td style={{ padding: '5px 8px', borderBottom: '1px solid #fef3c7' }}>
                            <span style={{
                              padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 700,
                              background: item.specialType === 'pending' ? '#fef3c7' : '#dcfce7',
                              color: item.specialType === 'pending' ? '#92400e' : '#166534',
                            }}>
                              {item.specialType === 'pending' ? 'Patient Owes' : 'Refund to Patient'}
                            </span>
                          </td>
                          <td style={{ padding: '5px 8px', borderBottom: '1px solid #fef3c7', textAlign: 'right', fontWeight: 700,
                            color: item.specialType === 'pending' ? '#d97706' : '#16a34a' }}>
                            ₹{(item.amount || 0).toLocaleString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div style={{ marginTop: 10 }}>
                    <button type="button" onClick={payPendingAmount}
                      disabled={outstandingSelections.size === 0}
                      style={{
                        background: outstandingSelections.size > 0 ? '#d97706' : '#e5e7eb',
                        color: outstandingSelections.size > 0 ? '#fff' : '#9ca3af',
                        border: 'none', borderRadius: 8, padding: '7px 16px',
                        fontSize: 12, fontWeight: 700, cursor: outstandingSelections.size > 0 ? 'pointer' : 'not-allowed',
                      }}>
                      Bill Selected ({outstandingSelections.size})
                    </button>
                  </div>
                </div>
              );
            })()}

            {/* ── Session-Based Billing Panel ── */}
            {showSessionPanel && sessionGroups.length > 0 && (() => {
              const thS = { padding: '6px 10px', textAlign: 'left', fontWeight: 700, fontSize: 12, color: '#78350f', borderBottom: '1px solid #fcd34d' };
              const tdS = { padding: '6px 10px', borderBottom: '1px solid #fef3c7', verticalAlign: 'middle', fontSize: 13 };
              const filledCount = new Set(
                [...sessionSelections]
                  .map(d => sessionGroups.find(g => g.designation === d && g.matchedService))
                  .filter(Boolean)
                  .map(g => g.matchedService._id.toString())
              ).size;
              return (
                <div style={{ background: '#fffbeb', border: '1.5px solid #fcd34d', borderRadius: 12, padding: '14px 16px', margin: '0 0 14px 0' }}>
                  {/* Header row */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 16 }}>📋</span>
                    <strong style={{ fontSize: 14, color: '#92400e' }}>Session-Based Billing</strong>
                    <span style={{ background: '#fde68a', color: '#78350f', borderRadius: 10, padding: '1px 8px', fontSize: 12, fontWeight: 700 }}>
                      {sessionGroups.reduce((s, g) => s + g.count, 0)} unbilled sessions
                    </span>
                    <span style={{ marginLeft: 'auto', fontSize: 11, color: '#a16207', fontStyle: 'italic' }}>
                      {`₹${patientBillsFIFO.reduce((a,b)=>a+(b.paid||0),0).toLocaleString()} paid · FIFO allocation`}
                    </span>
                    <button type="button" onClick={() => setShowSessionPanel(false)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#92400e', padding: '0 4px', lineHeight: 1 }}>×</button>
                  </div>

                  {/* Breakdown table */}
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ background: '#fef3c7' }}>
                          <th style={thS}>✓</th>
                          <th style={{ ...thS, textAlign: 'center' }}>Sessions</th>
                          <th style={thS}>Avg Fee</th>
                          <th style={thS}>Total</th>
                          <th style={thS}>Linked Service</th>
                          <th style={thS}>Already Selected</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sessionGroups.map((group, i) => {
                          const alreadySel = selectedServices.find(s => s._id.toString() === group.matchedService?._id.toString());
                          return (
                            <tr key={group.designation} style={{ background: i % 2 === 0 ? '#fff' : '#fffde7' }}>
                              <td style={tdS}>
                                <input
                                  type="checkbox"
                                  checked={sessionSelections.has(group.designation)}
                                  disabled={!group.matchedService}
                                  onChange={() => toggleSessionGroup(group.designation)}
                                />
                              </td>
                              <td style={{ ...tdS, textAlign: 'center', fontWeight: 700, color: '#1d4ed8', fontSize: 15 }}>{group.count}</td>
                              <td style={tdS}>₹{Math.round(group.avgFee)}</td>
                              <td style={{ ...tdS, fontWeight: 700 }}>₹{Math.round(group.totalFee)}</td>
                              <td style={tdS}>
                                {group.matchedService
                                  ? <span style={{ color: '#16a34a', fontWeight: 600 }}>✓ {group.matchedService.name}</span>
                                  : <span style={{ color: '#dc2626', fontSize: 11 }}>⚠ No matching service found</span>}
                              </td>
                              <td style={tdS}>
                                {alreadySel
                                  ? <span style={{ color: '#7c3aed', fontWeight: 600 }}>
                                      Qty {alreadySel.qty} → will set to <strong>{group.count}</strong>
                                    </span>
                                  : <span style={{ color: '#9ca3af' }}>—</span>}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Actions */}
                  <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
                    <button
                      type="button"
                      onClick={applySessionAutoFill}
                      disabled={filledCount === 0}
                      style={{
                        background: filledCount > 0 ? '#d97706' : '#e5e7eb', color: filledCount > 0 ? '#fff' : '#9ca3af',
                        border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 700, fontSize: 13,
                        cursor: filledCount > 0 ? 'pointer' : 'not-allowed',
                      }}
                    >
                      Auto-fill {filledCount} Service{filledCount !== 1 ? 's' : ''}
                    </button>
                    <button type="button" onClick={() => setShowSessionsModal(true)}
                      style={{ background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer', fontWeight: 600 }}>
                      📅 Show Sessions
                    </button>
                  </div>
                </div>
              );
            })()}

            {/* ── Bill Summary + Generate Bill ── */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, margin: '14px 0', flexWrap: 'wrap' }}>
              <div style={{ background: '#f8fafc', borderRadius: 8, padding: '8px 14px', border: '1px solid #e2e8f0' }}>
                <div style={{ fontSize: 9, fontWeight: 700, color: '#94a3b8', letterSpacing: 1 }}>PRE-TAX</div>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#1e293b' }}>₹{newBill.totalbeforetax}</div>
              </div>
              <div style={{ background: '#eff6ff', borderRadius: 8, padding: '8px 14px', border: '1px solid #bfdbfe' }}>
                <div style={{ fontSize: 9, fontWeight: 700, color: '#3b82f6', letterSpacing: 1 }}>INCL. TAX</div>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#1d4ed8' }}>₹{newBill.total}</div>
              </div>
              <button type="submit" className="btn btn-primary" style={{ marginLeft: 'auto' }}>Generate Bill</button>
            </div>

            {/* ── Per-Org Service Tables (side by side) ── */}
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {orgList.map(orgName => {
                const oc = getOrgColor(orgName);
                // Exclude pending/refund services — handled by Outstanding Balance panel
                const orgServices = servicesByPaymentType.filter(s => s.org === orgName && !/pending|refund/i.test(s.name));
                if (!orgServices.length) return null;
                return (
                  <div key={orgName} style={{
                    flex: '1 1 340px', minWidth: 300, maxWidth: '100%',
                    border: `2px solid ${oc.border}`, borderRadius: 10,
                    background: oc.bg, padding: '6px 8px', marginBottom: 8
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                      <span style={{ width: 10, height: 10, borderRadius: '50%', background: oc.dot }} />
                      <span style={{ fontWeight: 700, fontSize: 13, color: oc.text }}>{orgName}</span>
                      <span style={{ fontSize: 12, marginLeft: 'auto' }}>
                        <strong style={{ color: oc.text }}>{orgServices.filter(s => s.selected).length}</strong>
                        <span style={{ color: '#64748b' }}>/{orgServices.length} selected</span>
                      </span>
                    </div>
                    <CustomDataTable
                      columns={serviceColumns}
                      data={orgServices}
                      selectableRows
                      selectableRowSelected={row => row.selected === true}
                      onSelectedRowsChange={({ selectedRows }) => handleOrgServiceChange(orgName, selectedRows)}
                      dense
                    />
                  </div>
                );
              })}
            </div>

          </form>
        </div>
      )}

      {showBillComponent && (
        <BillPrintReport
          data={finalData}
          patientCData={stateData?.patientCData}
          onClose={() => {
            setShowBillComponent(false);
            // Re-show session panel if unbilled sessions still exist
            if (sessionGroups.length > 0) setShowSessionPanel(true);
          }}
          auth={auth}
        />
      )}

      {/* ── Sessions Modal ── */}
      {showSessionsModal && (() => {
        // FIFO allocation — same logic as PatientDashboard
        const _allComp = patientSessions
          .filter(s => s.status === 'Completed' && (s.visitCharges || 0) > 0)
          .slice().sort((a, b) => new Date(a.date || a.start) - new Date(b.date || b.start));
        const paidSum = patientBillsFIFO.reduce((acc, b) => acc + (b.paid || 0), 0);
        let _running = paidSum;
        const _allocMap = {};
        _allComp.forEach(s => {
          const cost = s.visitCharges || 0;
          // credited = how much of this session's cost is covered by remaining credit
          const credited = Math.max(0, Math.min(_running, cost));
          _allocMap[s._id] = { paid: _running >= cost, due: cost - credited };
          _running -= cost;
        });
        const sessionCredit = _running;
        let _lastPaid = null;
        for (let _pi = _allComp.length - 1; _pi >= 0; _pi--) {
          if (_allocMap[_allComp[_pi]._id]?.paid) { _lastPaid = _allComp[_pi]; break; }
        }
        const firstPending   = _allComp.find(s => !_allocMap[s._id]?.paid);
        const pendingCount   = _allComp.filter(s => !_allocMap[s._id]?.paid).length;
        const coverageEndDt  = _lastPaid    ? new Date(_lastPaid.date    || _lastPaid.start)    : null;
        const pendingStartDt = firstPending ? new Date(firstPending.date || firstPending.start) : null;

        const smLightTable = {
          table:     { style: { background: 'transparent' } },
          headRow:   { style: { background: 'rgba(25,118,210,0.06)', borderBottomColor: 'rgba(25,118,210,0.14)', minHeight: '42px' } },
          headCells: { style: { color: '#1976d2', fontSize: '0.72rem', fontWeight: '700', letterSpacing: '0.06em', textTransform: 'uppercase', paddingLeft: '12px' } },
          rows:      { style: { background: 'transparent', borderBottomColor: 'rgba(0,0,0,0.06)', minHeight: '46px' } },
          cells:     { style: { color: '#2d3436', fontSize: '0.83rem', paddingLeft: '12px' } },
          pagination:{ style: { background: 'transparent', color: '#1976d2', fontSize: '0.8rem' } },
          noData:    { style: { background: 'transparent', color: '#9ca3af' } },
        };

        const smColumns = [
          { name: 'Date', selector: r => new Date(r.date || r.start), format: r => new Date(r.date || r.start).toLocaleDateString('en-GB'), sortable: true, width: '108px' },
          { name: 'Start', selector: r => new Date(r.start).toLocaleTimeString('en-US', { hour12: true }), width: '100px' },
          { name: 'Therapist', selector: r => r.leadTherapist || r.therapist || r.therapistName || '—', sortable: true },
          { name: 'Status', selector: r => r.status, sortable: true, width: '105px',
            cell: r => <span style={{ color: r.status === 'Completed' ? '#2e7d32' : r.status === 'Skipped' ? '#d97706' : '#555', fontWeight: 600, fontSize: 12 }}>{r.status}</span> },
          { name: 'Charges', selector: r => r.visitCharges, sortable: true, right: true, width: '85px',
            cell: r => <span style={{ color: '#1976d2', fontWeight: 700 }}>₹{r.visitCharges || 0}</span> },
          { name: 'Payment', sortable: false, right: true, width: '130px',
            cell: r => {
              if (r.status !== 'Completed' || !(r.visitCharges > 0)) return <span style={{ color: '#d1d5db', fontSize: 11 }}>—</span>;
              const a = _allocMap[r._id];
              if (!a) return <span style={{ color: '#d1d5db', fontSize: 11 }}>—</span>;
              return a.paid
                ? <span style={{ background: '#dcfce7', color: '#16a34a', borderRadius: 6, padding: '2px 8px', fontSize: 12, fontWeight: 700 }}>✓ Paid</span>
                : <span style={{ background: '#fee2e2', color: '#dc2626', borderRadius: 6, padding: '2px 8px', fontSize: 12, fontWeight: 700 }}>✗ ₹{(a.due ?? r.visitCharges ?? 0).toLocaleString()} due</span>;
            }
          },
        ];

        return (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 99990, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            onClick={e => { if (e.target === e.currentTarget) setShowSessionsModal(false); }}>
            <div style={{ background: '#fff', borderRadius: 16, padding: '20px 24px', width: '95%', maxWidth: 860, maxHeight: '82vh', overflow: 'auto', position: 'relative', boxShadow: '0 16px 48px rgba(0,0,0,0.28)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <span style={{ fontSize: 22 }}>📅</span>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 16, color: '#1e293b' }}>Therapy Sessions</div>
                  <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                    {newPatient.name} · {patientSessions.length} total session{patientSessions.length !== 1 ? 's' : ''}
                  </div>
                </div>
                <button type="button" onClick={() => setShowSessionsModal(false)}
                  style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#64748b', lineHeight: 1 }}>×</button>
              </div>

              {/* Summary cards — same as PatientDashboard Sessions tab */}
              <div style={{ display: 'flex', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
                <div style={{
                  background: sessionCredit >= 0 ? '#f0fdf4' : '#fef2f2',
                  border: '1.5px solid ' + (sessionCredit >= 0 ? '#4ade80' : '#f87171'),
                  borderRadius: 10, padding: '10px 16px', flex: 1, minWidth: 140,
                }}>
                  <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 2 }}>
                    {sessionCredit >= 0 ? 'Advance Remaining' : 'Outstanding Amount'}
                  </div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: sessionCredit >= 0 ? '#16a34a' : '#dc2626' }}>
                    {sessionCredit >= 0 ? '+' : '-'}₹{Math.abs(sessionCredit).toLocaleString()}
                  </div>
                </div>
                <div style={{ background: '#fffbeb', border: '1.5px solid #fcd34d', borderRadius: 10, padding: '10px 16px', flex: 1, minWidth: 140 }}>
                  <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 2 }}>Total Paid</div>
                  <div style={{ fontSize: 18, fontWeight: 700, color: '#d97706' }}>₹{paidSum.toLocaleString()}</div>
                  <div style={{ fontSize: 11, color: '#9ca3af' }}>{patientBillsFIFO.length} bill{patientBillsFIFO.length !== 1 ? 's' : ''}</div>
                </div>
                {coverageEndDt && (
                  <div style={{ background: '#f5f3ff', border: '1.5px solid #a78bfa', borderRadius: 10, padding: '10px 16px', flex: 1, minWidth: 140 }}>
                    <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 2 }}>Sessions Paid Until</div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#7c3aed' }}>
                      {coverageEndDt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                    </div>
                  </div>
                )}
              </div>

              {/* Pending notice */}
              {pendingCount > 0 && (
                <div style={{
                  background: '#fef2f2', border: '1.5px solid #f87171',
                  borderRadius: 10, padding: '12px 16px', marginBottom: 12,
                  display: 'flex', alignItems: 'flex-start', gap: 10,
                }}>
                  <span style={{ fontSize: 18, flexShrink: 0, lineHeight: 1.3 }}>⚠</span>
                  <div>
                    <div style={{ fontWeight: 700, color: '#dc2626', fontSize: 13, marginBottom: 3 }}>
                      {pendingCount} session{pendingCount !== 1 ? 's' : ''} pending payment
                    </div>
                    <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.6 }}>
                      {pendingStartDt && (
                        <span>Starting from&nbsp;
                          <strong style={{ color: '#ef4444' }}>
                            {pendingStartDt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                          </strong>.&nbsp;
                        </span>
                      )}
                      Total outstanding:&nbsp;
                      <strong style={{ color: '#ef4444' }}>₹{Math.abs(Math.min(sessionCredit, 0)).toLocaleString()}</strong>.
                    </div>
                  </div>
                </div>
              )}

              <DataTable
                columns={smColumns}
                data={patientSessions}
                customStyles={smLightTable}
                highlightOnHover
                dense
                pagination
                paginationPerPage={15}
                noDataComponent={<p style={{ color: '#9ca3af', padding: 16 }}>No therapy sessions found.</p>}
              />
              <div style={{ marginTop: 14, textAlign: 'right' }}>
                <button type="button" onClick={() => setShowSessionsModal(false)}
                  style={{ background: '#f1f5f9', color: '#374151', border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 20px', fontSize: 13, cursor: 'pointer', fontWeight: 600 }}>
                  Close
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Toast ── */}
      {toast && (
        <div style={{
          position: 'fixed', bottom: 32, right: 32, zIndex: 99999,
          display: 'flex', alignItems: 'center', gap: 14,
          padding: '18px 24px', borderRadius: 14,
          maxWidth: 460, minWidth: 280, minHeight: 68,
          boxShadow: '0 8px 32px rgba(0,0,0,0.32)',
          color: '#fff', fontSize: 17, lineHeight: 1.5, fontWeight: 600,
          background: toast.type === 'error' ? '#dc2626'
            : toast.type === 'warning' ? '#d97706'
            : toast.type === 'success' ? '#16a34a'
            : '#1d4ed8',
          animation: 'slideInToast 0.28s cubic-bezier(0.34,1.56,0.64,1)',
        }}>
          <span style={{ fontSize: 26, lineHeight: 1, flexShrink: 0 }}>
            {toast.type === 'error' ? '✕' : toast.type === 'warning' ? '⚠' : toast.type === 'success' ? '✓' : 'ℹ'}
          </span>
          <span style={{ flex: 1 }}>{toast.msg}</span>
        </div>
      )}
      <style>{`
        @keyframes slideInToast { from { opacity:0; transform:translateY(16px) scale(0.96); } to { opacity:1; transform:translateY(0) scale(1); } }

        /* ── Search section ── */
        .search-section {
          margin-bottom: 18px;
        }
        .search-section > label {
          display: block;
          font-size: 12px;
          font-weight: 700;
          color: #64748b;
          letter-spacing: 0.5px;
          margin-bottom: 6px;
          text-transform: uppercase;
        }
        .search-section input[type="text"] {
          width: 100%;
          max-width: 500px;
          padding: 11px 16px;
          border-radius: 10px;
          border: 2px solid #e2e8f0;
          font-size: 15px;
          font-family: inherit;
          outline: none;
          transition: border-color 0.15s;
          background: #fff;
        }
        .search-section input[type="text"]:focus {
          border-color: #6366f1;
          box-shadow: 0 0 0 3px rgba(99,102,241,0.12);
        }

        /* ── Form card ── */
        .form-sections {
          background: #fff;
          border-radius: 14px;
          border: 1px solid #e8edf2;
          padding: 20px 24px 24px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.05);
        }
        .form-sections h4 {
          font-size: 16px;
          font-weight: 800;
          color: #1e293b;
          margin: 0 0 16px 0;
          padding-bottom: 12px;
          border-bottom: 2px solid #f1f5f9;
          letter-spacing: 0.1px;
        }

        /* ── Form rows ── */
        .ele {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px 14px;
          margin-bottom: 10px;
        }
        .ele > label {
          font-size: 12px;
          font-weight: 700;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.4px;
          min-width: 90px;
        }
        .ele input[type="text"],
        .ele input[type="number"],
        .ele select {
          padding: 8px 12px;
          border-radius: 8px;
          border: 1.5px solid #e2e8f0;
          font-size: 14px;
          font-family: inherit;
          color: #1e293b;
          background: #fff;
          min-width: 140px;
        }
        .ele input[readonly] {
          background: #f8fafc;
          color: #475569;
        }
        .ele input:focus, .ele select:focus {
          outline: none;
          border-color: #6366f1;
        }

        /* ── Generate Bill button ── */
        .form-sections .btn.btn-primary {
          padding: 11px 28px;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 700;
          background: #4f46e5;
          color: #fff;
          border: none;
          cursor: pointer;
          letter-spacing: 0.2px;
          box-shadow: 0 4px 14px rgba(79,70,229,0.3);
        }
        .form-sections .btn.btn-primary:hover {
          background: #4338ca;
        }
        .form-sections .btn.btn-secondary {
          padding: 9px 20px;
          border-radius: 9px;
          font-size: 14px;
          font-weight: 600;
          background: #f1f5f9;
          color: #475569;
          border: 1.5px solid #e2e8f0;
          cursor: pointer;
        }
      `}</style>

    </div>
  );
};

export default Billing;
